import usePostData from '../../../../../hooks/postHook';

export const useToggleRead = ({ ticketId }) => {
  const [{ body, isLoading, isError, error }, doToggleRead] = usePostData(
    `office_support_ticket/${ticketId}/read`
  );

  return { body, isLoading, isError, error, doToggleRead };
};
